import React, { useContext, useState } from 'react';

import { AppContext } from 'App.context';
import ImageSlider from '../ImageSlider/ImageSlider';
import UrlCarousel from '../UrlCarousel/UrlCarousel';

export default function CarouselSelector({
  images,
  hotel,
  paperlessCarouselType,
  paperlessCarouselUrl,
}) {
  const {
    appActions: { translate },
  } = useContext(AppContext);
  const [useImageSlider, setUseImageSlider] = useState(paperlessCarouselType == 'Image');

  return (
    <div>
      <p style={{ marginBottom: 8 }}>{translate('appearence.carouselSelectType')}</p>
      <select
        name="carouserSelector"
        value={useImageSlider ? 'images' : 'url'}
        onChange={e => setUseImageSlider(e.target.value === 'images')}
      >
        <option value="images">{translate('appearence.imageLiteral')}</option>
        <option value="url">URL</option>
      </select>
      {useImageSlider ? (
        <ImageSlider images={images} hotel={hotel} />
      ) : (
        <UrlCarousel paperlessCarouselUrl={paperlessCarouselUrl} images={images} hotel={hotel} />
      )}
    </div>
  );
}
